module.exports = __webpack_public_path__ + "static/media/search-black.bd1c424c.svg";